// extracted by mini-css-extract-plugin
export var container = "_5j-0";
export var disabled = "_5j-4";
export var fullWidth = "_5j-3";
export var lined = "_5j-1";
export var selected = "_5j-5";
export var tab = "_5j-2";